import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';

export default function initialisationOptionBlocage(ligneCommande) {
  ligneCommande.etatProvisoire = AUCUN;
  ligneCommande.etatObtenu = AUCUN;
  ligneCommande.messagesAvertissement = null;
  ligneCommande.rangOption = null;
  if (ligneCommande.lignesCommande) {
    ligneCommande.lignesCommande.forEach((ligne) => {
      ligne.etatObtenu = AUCUN;
    });
  }
  ligneCommande.etatDeLaDemande = true;
}
